/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { SurveyParticipation } from '../models/SurveyParticipation';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class AdminParticipationService {

    /**
     * Switch Participation Template Visibility
     * @returns any Success
     * @throws ApiError
     */
    public static switchTemplateVisibility({
        participationId,
        requestBody,
    }: {
        /**
         * Participation Id
         */
        participationId: string,
        requestBody?: {
            isPublished: boolean;
        },
    }): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/admin/participation/{participationId}',
            path: {
                'participationId': participationId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Update Participation Template
     * @returns any Success
     * @throws ApiError
     */
    public static updateParticipationTemplate({
        participationId,
        requestBody,
    }: {
        /**
         * Participation Id
         */
        participationId: string,
        requestBody?: {
            participationName: string;
            surveyVendorId?: string;
            surveyVendorName?: string;
            surveyJobProfileId?: string;
            surveyJobProfileName?: string;
            surveyModuleIds?: Array<string>;
        },
    }): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/admin/participation/{participationId}',
            path: {
                'participationId': participationId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Delete Participation Template
     * @returns any Success
     * @throws ApiError
     */
    public static deleteParticipationTemplate({
        participationId,
    }: {
        /**
         * Participation Id
         */
        participationId: string,
    }): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/admin/participation/{participationId}',
            path: {
                'participationId': participationId,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * get list of survey participations
     * @returns any Success
     * @throws ApiError
     */
    public static listAdminParticipations({
        surveyVendorId,
        search,
    }: {
        /**
         * Filter by survey vendor ID
         */
        surveyVendorId: string,
        /**
         * Search by participation name
         */
        search?: string,
    }): CancelablePromise<{
        rows?: Array<SurveyParticipation>;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/admin/participation',
            query: {
                'search': search,
                'surveyVendorId': surveyVendorId,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

}
